// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2Suaz","header":"Messages_header__iWkiI"};